<template>
    <div>
        <DashboardSuperAdmin v-if="['super_admin','quote_approver','sales_reps','sales_admin'].includes(user.role.name)" />
        <DashboardCommon v-else />
    </div>
</template>

<script>
import {computed, onMounted} from 'vue';
import {useStore} from "vuex";

import DashboardSuperAdmin from './DashboardSuperAdmin.vue'
import DashboardCommon from './DashboardCommon.vue'

export default {
    props: [],
	emits: [],
	components: {
        DashboardSuperAdmin,
        DashboardCommon
	},
    setup(){
        const store = useStore();

        let user = computed(function () { return store.state.user });

		onMounted(() => {
            
		});

		return {
            user
		}
	},
	data() {
		return {
            orders:[
                {
                    id: 1,
                    name: ''
                },
            ],
            paginatedOrders: [],
            perPage: 5,
		}
	},
    mounted() {
        
    },
	methods: {
		updateRow(val) {
            this.paginatedOrders = val;
        }
	}
}
</script>